import { Injectable } from '@angular/core';
import {
  ApolloClient,
  InMemoryCache,
  ApolloLink,
  NormalizedCacheObject,
  HttpLink,
} from '@apollo/client/core';
import { createClient } from 'graphql-ws';
import { GraphQLWsLink } from '@apollo/client/link/subscriptions';
import { getMainDefinition } from '@apollo/client/utilities';
import { Kind, OperationTypeNode } from 'graphql';
import { createWsLinkForRole } from '../../app.config';
import { AuthService } from './auth.service';
import { TranslateService } from '@ngx-translate/core';
@Injectable({ providedIn: 'root' })
export class ApolloRoleService {
  private clients: Record<string, ApolloClient> = {};
  constructor(
    private auth: AuthService,
    private translate: TranslateService,
  ) { }
  getClient(
    role:
      | 'user'
      | 'manager'
      | 'anonymous'
      | 'installatore'
      | 'tecnico'
      | 'segnalatore'
      | 'amico'
      | 'superadmin'
      | 'geomarketing'
  ) {
    if (!this.clients[role]) {
      this.clients[role] = this.createApolloClientWithRole(role);
    }
    return this.clients[role];
  }
  stopClient(role: string) {
    const client = this.clients[role];
    if (client) {
      const wsLink = client.link as GraphQLWsLink;
      (wsLink as any)?.client?.dispose?.();
      delete this.clients[role];
    }
  }
  private createApolloClientWithRole(role: string) {
    const wss = createWsLinkForRole(role, this.auth, this.translate);
    return new ApolloClient({
      link: wss,
      cache: new InMemoryCache({
        typePolicies: {
          cer: {
            fields: {
              cer_padre: {
                merge: true,
              },
            },
          },
        },
      }),
    });
  }
}
